// extracted by mini-css-extract-plugin
module.exports = {"PendingVerificationPage":"PendingVerificationPage_PendingVerificationPage__1mO2P","main":"PendingVerificationPage_main__3FBkm"};